import { renderFormLike } from './form.js';

/**
 * RESERVAS — Pedir cita / reservar mesa.
 *
 * Es el bloque 'form' especializado para captar RESERVAS (restaurantes, clínicas,
 * peluquerías, talleres…): fecha, franja horaria y nº de personas, además de los
 * datos de contacto. NO duplica la maquinaria del formulario: reutiliza
 * renderFormLike() de blocks/form.js con kind:'reservas' (DRY) → mismo <form
 * class="ai-form">, mismos .form-field, mismo honeypot y mismo mensaje de éxito.
 *
 * En consecuencia:
 *   · El envío lo cablea el MISMO handler global (animations/form-submit.js): en el
 *     sitio publicado hace POST a /site_lead/, que guarda TODOS los campos (fecha,
 *     franja, personas…) en Lead.data por su etiqueta. Sin backend nuevo.
 *   · La extracción reutiliza el CUSTOM_HANDLER 'form' (core/extractor.js): solo la
 *     etiqueta es editable inline; type/options/required/min/max se preservan.
 *
 * Los tipos de campo date/select/number los aporta form.js::renderField (ampliado);
 * el contenido por defecto (campos de reserva) vive en la plantilla del editor
 * (editor/tools.js) y es 100% editable por el cliente o generable por la IA.
 *
 * Variantes (heredadas de form): v1 = Centrado · v2 = Split texto + formulario.
 */
export const reservasBlock = (rawProps, index = 0) => renderFormLike(rawProps, index, { kind: 'reservas' });
